module.exports = {"411728001":"瞿阳街道","411728002":"车站街道","411728003":"莲花湖街道","411728004":"褚堂街道","411728005":"吴房街道","411728102":"玉山镇","411728103":"查岈山镇","411728104":"石寨铺镇","411728105":"和兴镇","411728106":"沈寨镇","411728107":"阳丰镇","411728108":"常庄镇","411728109":"花庄镇","411728204":"槐树乡","411728209":"文城乡","411728400":"工业园区","411728500":"嵖岈山风景区","411728501":"凤鸣谷风景区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411728.json
// module id = 1817
// module chunks = 0